import React from "react";
import { bool } from "prop-types";
import * as style from "./styles.module.scss";

const PulseLoader = ({ isSmall = false }) => {
  return (
    <div
      className={`${style.laBallPulse} ${style.laDark} ${
        isSmall ? style.lasm : style.la3x
      }`}
    >
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

PulseLoader.propTypes = {
  isSmall: bool,
};

export default PulseLoader;
